<template>
  <div>
      <div class="container2">
          	<div class="type-text" :style="{color: dateType==='year'?'#58B7FF':''}" @click="getModelCountList('year')">年(近一年)</div>
            <div class="type-text type-left" :style="{color: dateType==='month'?'#58B7FF':''}" @click="getModelCountList('month')">月(近一月)</div>
      </div>
      <div class="model-text">
            <el-input v-model="modelInput" placeholder="请输入型号" clearable style="width:215px;margin-left:10px;" ></el-input>
            <el-date-picker v-model="date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
            <el-button size="small"  type="primary" style="width: 100px;height:40px;font-size:15px;" @click="getModelCountList2">查询</el-button>
      </div>
      <div class="echart" style="margin-top:20px;" id="mychart" :style="myChartStyle"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      xData: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], //横坐标
      countData: [23, 24, 18, 25, 27, 28, 25, 23, 24, 18, 25, 27, 28, 25], //数据
      qualityData: [23, 24, 18, 25, 27, 28, 25, 23, 24, 18, 25, 27, 28, 25], //数据
      myChartStyle: { width: "100%", height: "500px" }, //图表样式
      modelInput: null,
      dateType: "year",
      date: null
    };
  },
  mounted() {
    this.getModelCountList(this.dateType);
  },
  methods: {
    initEcharts() {
      // 基本柱状图
      const option = {
        title: {
          text: '员工统计',
          left: '20',
          top: '20'
        },
        // 图例
        legend: {
          data: ["生产量", "良品量"],
          top: "20"
        },
        xAxis: {
          data: this.xData,
          axisLabel: {
            interval: 0,
            rotate: 50,
          }
        },
        dataZoom: [
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 50,
            xAxisIndex: [0],
          },
        ],
        yAxis: {
            axisLabel: {
                formatter: '{value} 台'
            }
        },
        series: [
          {
            name: '生产量',
            type: "bar", //形状为柱状图
            data: this.countData,
            barGap: "0%"
          },
           {
            name: '良品量',
            type: "bar", //形状为柱状图
            data: this.qualityData
          }
        ]
      };
      let myChart = echarts.getInstanceByDom(document.getElementById("mychart"))
      if(myChart == null){
          myChart = echarts.init(document.getElementById("mychart"));
      }
      myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    getModelCountList(dateType){
        this.dateType = dateType;
        this.$axios.get('/device_test/select_date_user_quality_count',{
            params:{               //将URL地址拼接参数的形式换成传入params对象的形式
                token: 'lijian',
                customer: 'lijian',
                deviceType: '指纹头',
                testType: '指纹测试',
                dateType: dateType,
                deviceModel: this.modelInput,
            }
        }).then(res=>{   //这里使用箭头函数的形式
            if(res.data.code==200){
                this.modelInput = null;
                this.date = null;
                if(res.data.data.length==0){
                    this.$message({
                        message: '数据为空',
                        type: "error",
                        showClose: true,
                    });
                    return;
                }
                if(dateType==='year'){
                    let xDataModel = [];
                    let countData = [];
                    let qualityData = [];
                    for(let i=0;i<res.data.data.length;i++){
                        xDataModel.push(res.data.data[i].nickName);
                        countData.push(res.data.data[i].count);
                        qualityData.push(res.data.data[i].qualityDevice);
                    }
                    this.xData = xDataModel;
                    this.countData = countData;
                    this.qualityData = qualityData;
                }else if(dateType==='month'){
                    let xDataModel = [];
                    let countData = [];
                    let qualityData = [];
                    for(let i=0;i<res.data.data.length;i++){
                        xDataModel.push(res.data.data[i].nickName);
                        countData.push(res.data.data[i].count);
                        qualityData.push(res.data.data[i].qualityDevice);
                    }
                    this.xData = xDataModel;
                    this.countData = countData;
                    this.qualityData = qualityData;
                }
                this.initEcharts();
            }else{
                this.$message({
                    message: res.data.message,
                    type: "error",
                    showClose: true,
                });
            }
        })        
    },
    getModelCountList2(){
        this.$axios.get('/device_test/select_user_quality_count',{
            params:{               //将URL地址拼接参数的形式换成传入params对象的形式
                token: 'lijian',
                customer: 'lijian',
                deviceType: '指纹头',
                testType: '指纹测试',
                deviceModel: this.modelInput,
                date: this.date
            }
        }).then(res=>{   //这里使用箭头函数的形式
            if(res.data.code==200){
                if(res.data.data.length==0){
                    this.$message({
                        message: '数据为空',
                        type: "error",
                        showClose: true,
                    });
                    this.modelInput = null;
                    this.date = null;
                    return;
                }
                let xDataModel = [];
                let countData = [];
                let qualityData = [];
                for(let i=0;i<res.data.data.length;i++){
                    xDataModel.push(res.data.data[i].nickName);
                    countData.push(res.data.data[i].count);
                    qualityData.push(res.data.data[i].qualityDevice);
                }
                this.xData = xDataModel;
                this.countData = countData;
                this.qualityData = qualityData;
                this.dateType = null;
                this.initEcharts();
            }else{
                this.$message({
                    message: res.data.message,
                    type: "error",
                    showClose: true,
                });
            }
        })        
    },
    addActive($event) {
		$event.currentTarget.className = 'content-p active'
	},
	removeActive($event) {
		$event.currentTarget.className = 'type-text'
	},

  }
};
</script>

<style scoped>
    .container2{
		width: 100%;
		display: flex;
        justify-content: center;
        align-items: center;
	}

    .type-left{
        margin-left: 80px;
	}
    
    .type-text{
        font-size: 30px;
        cursor: pointer;
    }
    .model-text{
        margin-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/Personnel.vue